export const PZH_CONTRACT_FEE_FULL = 490;
export const PZH_CONTRACT_FEE_HALF = 245;
export const PZH_CONTRACT_CANCELLATION_PERIOD = 17;

export const PZH_CONTRACT_FEE_TYPE_FULL = 'full_contract';
export const PZH_CONTRACT_FEE_TYPE_HALF = 'half_contract';
